import "./pages/login/Axios-interceptor";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PermissionProvider } from "./pages/login/PermissionContext";
import { PatientProvider } from "./context/PatientContext";



ReactDOM.render(
  <PermissionProvider>
    <PatientProvider>
      <App />
    </PatientProvider>
    <ToastContainer
      position="top-center"
      autoClose={2000}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      theme="light"
    />
  </PermissionProvider>,
  // <App />,
  document.getElementById("root")
);
